import Vue from 'vue'
import Router from 'vue-router'
import my from '../components/my.vue'
import index from '../components/index.vue'
import job from '../components/job.vue'
import login from '../components/login.vue'
import loginRe from '../components/loginRe.vue'
import upload from '../components/upload.vue'
import ai from '../components/ai.vue'
import workroom from '../components/workroom.vue'
import myReceiveResume from '../components/myReceiveResume.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: "/",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {keepAlive: true}
    },
    {
      path: '/job/:id',
      name: 'job',
      component: job,
      meta: {keepAlive: true}
    },
    {
      path: '/ai/:id',
      name: 'ai',
      component: ai
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/workroom',
      name: 'workroom',
      component: workroom
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/loginRe',
      name: 'loginRe',
      component: loginRe
    },
    {
      path: '/upload/:id',
      name: 'upload',
      component: upload
    },
    {
      path: '/resume',
      name: 'myReceiveResume',
      component: myReceiveResume
    }
  ]
})


export default router
